import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const UpdateUser = () => {
    const [user, setUser] = useState({});
    const { id } = useParams();

    useEffect(() => {
        fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/users/${id}`)
            .then((res) => res.json())
            .then((info) => setUser(info));
    }, [id]);

    const handleUser = (event) => {
        event.preventDefault();
        const userEmail = event.target.userEmail.value;
        const userRole = event.target.userRole.value;

        const userEdit = {
            userEmail,
            userRole
        };

        fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/upadete-users/${id}`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(userEdit),
        })
            .then((res) => res.json())
            .then(() => {
                alert('User Is Updated');
            });
    };

    return (
        <>
            <section id="services" className="services-area vh-100 d-flex align-items-center justify-content-center">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-md-8">
                            <h3 className="text-center mb-4">Update User Email</h3>
                            <form className="contact-form" onSubmit={handleUser}>
                                <div className="form-group mb-3">
                                    <input
                                        type="email"
                                        className="form-control form-control-lg shadow-lg p-3 mb-3 bg-white rounded"
                                        name="userEmail"
                                        defaultValue={user.userEmail || ''}
                                        placeholder="User Email"
                                        required
                                    />
                                </div>
                                <input
                                    type="hidden"
                                    name="userRole"
                                    defaultValue={user.userRole || 'Admin'}
                                />
                                <div className="text-center">
                                    <button type="submit" className="theme-btn btn-one" data-animation="fadeInRight" data-delay=".8s">
                                        Update User Email
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default UpdateUser;
